
import { Options, Vue } from "vue-class-component"; //基本需要\
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readGetSimpleDateOptions,
  readGetSimpleTypeOptions,
  readGetSimpleDeviceOptions,
  readGetSimpleData,
  readGetSimpleByData,
  readGetSimplSubtypeOptions,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchSimpleDateOptions,
  dispatchSimpleTypeOptions,
  dispatchSimpleDeviceOptions,
  dispatchSimpleData,
  dispatchSimpleByData,
  dispatchNzmUploadReportImage,
  dispatchSimpleSubtypeOptions,
} from "@/store/performance/actions";
import { dispatchUpdateMyLastProject } from "@/store/main/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";

import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class DcStatistics extends Vue {
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public totalClass = ["逻辑", "动画", "粒子", "渲染"];
  public totalSubClass = ["GamePub", "NGUI", "其他"];
  public subClass = [
    "GamePub-赛车",
    "GamePub-单局逻辑",
    "GamePub-Avatar",
    "GamePub-DEBUG",
    "GamePub-网络",
    "GamePub-相机",
    "GamePub-其他",
  ];
  public labelWidth(item) {
    if (
      this.totalClass.includes(item.type) &&
      this.totalClass.includes(item.label)
    ) {
      return "0px";
    }
    if (
      this.totalClass.includes(item.type) &&
      this.totalClass.includes(item.label) == false
    ) {
      return "10px";
    }
    if (
      this.totalSubClass.includes(item.type) &&
      this.totalSubClass.includes(item.label)
    ) {
      return "10px";
    }
    if (
      this.totalSubClass.includes(item.type) &&
      this.totalSubClass.includes(item.label) == false
    ) {
      return "20px";
    }
    if (
      this.subClass.includes(item.type) &&
      this.subClass.includes(item.label)
    ) {
      return "20px";
    }
    if (
      this.subClass.includes(item.type) &&
      this.subClass.includes(item.label) == false
    ) {
      return "30px";
    }
  }
  public filterList = {
    date: "",
    type: "",
    subtype: "",
  };
  public selected_scene = "Total";
  public selected_scene_class = "Total";
  public selected_scene1 = "";
  public getHead(item) {
    if (item == "label") {
      if (this.filterList.type == "3" || this.filterList.type == "4") {
        return "测试皮肤";
      } else {
        return "测试场景";
      }
    } else {
      return item;
    }
  }
  public async selectChange(scene) {
    this.resBase64 = [];

    await this.trendLabel(scene).forEach((v, index) => {
      this.drawPieChart(v, index);
    });
  }
  public async selectChange3(scene) {
    this.resBase64 = [];

    await this.trendLabel1(scene).forEach((v, index) => {
      this.drawPieChart1(v, index);
    });
  }
  // public allTable(){
  //   for(let i in readGetSimpleByData(store).overview){
  //       let tbList=[];
  //       console.log(readGetSimpleByData(store).overview[i])
  //      for(let m in  readGetSimpleByData(store).overview[i]){
  //       for(let x in readGetSimpleByData(store).overview[i][m].sub){
  //          tbList.push(x)
  //       }
  //      }
  //      console.log(tbList)
  //   }
  // }
  public getType(k, i) {
    if (i === 1) {
      if (this.filterList.type == "3" || this.filterList.type == "4") {
        return (k = "测试皮肤");
      } else {
        return (k = "测试场景");
      }
    } else {
      return k;
    }
  }
  public typeName() {
    if (this.filterList.type == "3" || this.filterList.type == "4") {
      return "测试皮肤";
    } else {
      return "测试场景";
    }
  }
  public imgHead = ["机型", "测试场景", "查看火焰图", "火焰图下载", "数据下载"];
  public localProject = Number(getLocalProject());
  public async mounted() {
    this.loading = true;
    if (this.$route.query.date && this.$route.query.subtype) {
      (this.filterList.date as any) = this.$route.query.date;
      this.formMail.title =
        "【GR自动化】QQ飞车手游SimplePerf自动化测试报告-" +
        this.filterList.date;
      (this.filterList.type as any) = Number(this.$route.query.report_type);
      // (this.filterList.uuid as any) = this.$route.query.UUID;
      (this.filterList.subtype as any) = Number(this.$route.query.subtype);
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });

      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.filterList.date,
      });

      // await dispatchSimpleDeviceOptions(store, {
      //   project: this.localProject,
      //   date: this.filterList.date,
      //   report_type: Number(this.filterList.type),
      //   subtype: Number(this.filterList.subtype),
      // });
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });

      await dispatchSimpleByData(store, {
        project: this.localProject,
        date: this.filterList.date,
        report_type: Number(this.filterList.type),
        UUID: "",
        subtype: Number(this.filterList.subtype),
      });

      await this.simpleByData;
      await this.picData;
      await this.textData;
      await this.ehcartList;

      this.selected_scene =
        this.tableObj1.trend.Total === undefined ? this.ehcartList[0] : "Total";
      this.selected_scene_class =
        this.tableObj1.trend_class.Total === undefined
          ? this.ehcartList[0]
          : "Total";

      if (this.simpleByData.trend.Total === undefined) {
        this.selected_scene1 = this.ehcartList[0];
      } else {
        this.selected_scene1 = "Total";
      }
      await this.$nextTick(() => {
        this.unityMainTable();
      });
      await this.trendLabel(this.selected_scene).forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart(v, index);
        });
      });
      await this.trendLabel1(this.selected_scene_class).forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart1(v, index);
        });
      });
    } else {
      await dispatchSimpleDateOptions(store, {
        project: this.localProject,
      });
      this.filterList.date = readGetSimpleDateOptions(store)[0].date;
      this.formMail.title =
        "【GR自动化】QQ飞车手游SimplePerf自动化测试报告-" +
        this.filterList.date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
      });
      this.filterList.type = readGetSimpleTypeOptions(store)[0].report_type;
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      // await dispatchSimpleDeviceOptions(store, {
      //   project: this.localProject,
      //   date: this.dateOptions.length > 0 ? this.filterList.date : "",
      //   report_type:
      //     this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      //   subtype: Number(this.filterList.subtype),
      // });
      // this.filterList.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
      await dispatchSimpleByData(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
        UUID: "",
        subtype: Number(this.filterList.subtype),
      });
      // await dispatchSimpleData(store, {
      //   project: this.localProject,
      //   date: this.dateOptions.length > 0 ? this.filterList.date : "",
      //   report_type:
      //     this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      //   UUID: '',
      //   subtype: Number(this.filterList.subtype),
      // });
      this.$router.push({
        query: {
          ...this.$route.query,
          date: this.filterList.date,
          report_type: Number(this.filterList.type),
          subtype: Number(this.filterList.subtype),
          UUID: "",
        },
      });

      await this.simpleByData;

      await this.picData;
      await this.textData;

      this.resBase64 = [];
      // (this.trendData as any).label.forEach((v, index) => {
      //   this.drawPieChart(v, index);
      // });
      this.selected_scene =
        this.tableObj1.trend.Total === undefined ? this.ehcartList[0] : "Total";
      this.selected_scene_class =
        this.tableObj1.trend_class.Total === undefined
          ? this.ehcartList[0]
          : "Total";

      if (this.simpleByData.trend.Total === undefined) {
        this.selected_scene1 = this.ehcartList[0];
      } else {
        this.selected_scene1 = "Total";
      }
      await this.$nextTick(() => {
        this.unityMainTable();
      });
      await this.trendLabel(this.selected_scene).forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart(v, index);
        });
      });
      await this.trendLabel1(this.selected_scene_class).forEach((v, index) => {
        this.$nextTick(() => {
          this.drawPieChart1(v, index);
        });
      });
    }
    //   for(let i in this.tableObj1.data){
    //     if(i!='UnityMain中各模块消耗'){
    //       this.tableObj1.data[i].list.forEach((v,index) => {

    //      let chil=document.getElementById(index+i+String(v.is_first))
    //      let num=(chil.children[0] as any).getAttribute('rowspan')

    //      if(num=='1'&&String(v.is_first)=='false'){

    //        chil.removeChild(chil.children[0]);
    //      }

    //    });
    //     }

    // }
    //  await this.allTable()
    await this.overview_old_data;
    this.loading = false;
  }

  public getfix(item) {
    if (typeof item == "number") {
      return (item * 100).toFixed(2);
    } else {
      return "--";
    }
  }
  public getNum(item1, item2, type) {
    if (item1 == "") {
      return "";
    }
    item1 = Number(item1);
    item2 = Number(item2);
    if (type == "avg_fps_single" || type == "avg_fps") {
      if (item1 > item2) {
        return "(" + (item1 - item2).toFixed(2) + "↑" + ")";
      } else if (item1 < item2) {
        return "(" + (item2 - item1).toFixed(2) + "↓" + ")";
      }
      if (item1 === item2) {
        return "(--)";
      }
    }
    // if (type === "avg_fps") {
    //    if (item1 > item2) {
    //     return "(" + (item1 - item2).toFixed(2) + "↑" + ")";
    //   } else if (item1 < item2) {
    //     return "(" + (item2 - item1).toFixed(2) + "↓" + ")";
    //   }
    //   if (item1 === item2) {
    //     return "(--)";
    //   }
    // }
    else {
      if (item1 > item2) {
        return "(" + ((item1 - item2) * 100).toFixed(2) + "↑" + ")";
      } else if (item1 < item2) {
        return "(" + ((item2 - item1) * 100).toFixed(2) + "↓" + ")";
      }
      if (item1 === item2) {
        return "(--)";
      }
    }
  }
  public getNum1(item1, item2, type) {
    if (item1 == "") {
      return "";
    } else {
      if (type == "UnityMain" && typeof item1 == "number") {
        if (item1 > item2) {
          return ((item1 - item2) * 100).toFixed(2) + "↑";
        } else if (item1 < item2) {
          return ((item2 - item1) * 100).toFixed(2) + "↓";
        }
      }
      if (type == "UnityMain1" && typeof item1 == "number") {
        if (item1 > item2) {
          return item1 - item2 + "↑";
        } else if (item1 < item2) {
          return item2 - item1 + "↓";
        }
      }
      if (item1 === item2) {
        return "--";
      }
    }
  }
  public getNum3(item1, item2, type) {
    if (type == "UnityMain") {
      item1.forEach((v) => {
        item2.forEach((k) => {
          if (
            v.uuid === k.uuid &&
            v.func === k.func &&
            v.sub_func === k.sub_func
          ) {
            if (v.sub_func_value > k.sub_func_value) {
              return (
                ((v.sub_func_value - k.sub_func_value) * 100).toFixed(2) + "↑"
              );
            } else if (v.sub_func_value < k.sub_func_value) {
              return (
                ((v.sub_func_value - k.sub_func_value) * 100).toFixed(2) + "↓"
              );
            }
            if (v.sub_func_value === k.sub_func_value) {
              return "--";
            }
          }
        });
      });
    }
  }

  public trendLabel(item) {
    let list = [];

    if (JSON.stringify(this.tableObj1) != "{}") {
      for (let i in this.tableObj1.trend[item]) {
        list.push(i);
      }
    }

    return list;
  }
  public trendLabel1(item) {
    let list = [];

    if (JSON.stringify(this.tableObj1) != "{}") {
      for (let i in this.tableObj1.trend_class[item]) {
        list.push(i);
      }
    }

    return list;
  }
  public selectChange1() {
    this.$nextTick(() => this.unityMainTable());
  }
  public get headList() {
    let list = [
      { name: "机型", value: "uuid" },
      { name: "模块名字", value: "label" },
      { name: "机型", value: "Last" },
      { name: "label", value: "Cur" },
      { name: "机型", value: "Change" },
    ];
    return list;
  }
  // public unityMainTable() {
  //   let list = [];

  //   let tbodALL = [];
  //   let l = [];

  //   if (JSON.stringify(readGetSimpleByData(store)) != "{}") {
  //     // readGetSimpleByData(store).data['UnityMain中各模块消耗'].list=[
  //     //     {
  //     //     label: "Total",

  //     //     GamePub_LateUpdate: 0.1063229468676826,
  //     //     UIPanel_LateUpdate: 0.050116314821636386,

  //     //     GamePub_Update: 0.2931141808976708,

  //     //     DoForwardShaderRenderLoop: 0.1091416146618252,

  //     //     is_first: true,
  //     //     length: 1,
  //     //     uuid: "6c8a117",
  //     //     old: {

  //     //     }
  //     // },
  //     // {
  //     //     label: "Total",

  //     //     GamePub_LateUpdate: 0.09859965376149363,
  //     //     UIPanel_LateUpdate: 0.0557543864912948,
  //     //     abc:2222,
  //     //     ccc:333,

  //     //     DoForwardShaderRenderLoop: 0.12601506608834964,

  //     //     is_first: true,
  //     //     length: 1,
  //     //     uuid: "12412412",
  //     //     old: {}
  //     // }
  //     // ]
  //     readGetSimpleByData(store)?.data["UnityMain中各模块消耗"].list.forEach(
  //       (v) => {
  //         if (v.label === this.selected_scene1) {
  //           list.push(v);
  //         }
  //       }
  //     );
  //     console.log(list);
  //     list.forEach((m, index) => {
  //       let tbList = [];
  //       for (let obj in m) {
  //         if (
  //           obj != "is_first" &&
  //           obj != "length" &&
  //           obj != "old" &&
  //           obj != "label" &&
  //           obj != "uuid"
  //         ) {
  //           tbList.push(obj);
  //         }
  //       }
  //       console.log(tbList);
  //       tbList.forEach((v, x) => {
  //         tbodALL.push({
  //           uuid: list[index].uuid,
  //           label: v,
  //           Last:
  //             JSON.stringify(list[index].old) != "{}"
  //               ? list[index].old[v]
  //               : "--",
  //           Cur: list[index][v],
  //           length: tbList.length,
  //           Change: "",
  //           is_first: x === 0 ? true : false,
  //         });
  //       });
  //     });
  //     console.log(tbodALL);
  //     //   for(let obj in list[0]){
  //     //     let tbodList=[]
  //     //   if(obj!='is_first'&&obj!='length'&&obj!='old'&&obj!='label'&&obj!='uuid'){
  //     //       tbodList.push(obj)
  //     //   }
  //     //     console.log(tbodList)

  //     // }
  //   }
  //   return tbodALL;
  // }
  public get overview_data() {
    const overview = readGetSimpleByData(store)?.overview;
    let result = [];
    // UUID层

    for (let device in overview?.new) {
      let device_index = 0;
      // 获取合并行数
      let _device_length = 0;
      for (let _func in overview.new[device]) {
        _device_length += Object.keys(overview.new[device][_func].sub.percent)
          .length;
      }
      // 第一分类
      for (let _func in overview.new[device]) {
        let index = 0;
        if (overview.new[device][_func]) {
          // 第二层分类
          let sub_index = 0;
          for (let _sub_func in overview.new[device][_func].sub.percent) {
            result.push({
              uuid: device,
              func: _func,
              func_value: overview.new[device][_func].value,
              sub_func: _sub_func,
              sub_func_value:
                overview.new[device][_func].sub.percent[_sub_func],
              device_index: device_index,
              index: index,
              // sub_index: sub_index,
              device_length: _device_length,
              length: Object.keys(overview.new[device][_func].sub.percent)
                .length,
              // sub_length: Object.keys(overview[device][_func].sub).length,
            });
            sub_index += 1;
            device_index += 1;
            index += 1;
          }
        } else {
          result.push({
            uuid: device,
            func: _func,
            func_value: overview.new[device][_func].value,
            sub_func: "",
            sub_func_value: "",
            device_index: device_index,
            index: index,
            // sub_index: 0,
            device_length: Object.keys(overview.new).length,
            length: Object.keys(overview.new[device]).length,
            // sub_length: 1,
          });
          device_index += 1;
          index += 1;
        }
      }
    }
    result.forEach((v) => {
      this.overview_old_data.forEach((k) => {
        if (
          v.uuid === k.uuid &&
          v.func === k.func &&
          v.sub_func === k.sub_func
        ) {
          if (v.sub_func_value > k.sub_func_value) {
            v.sub_old =
              ((v.sub_func_value - k.sub_func_value) * 100).toFixed(2) + "↑";
          } else if (v.sub_func_value < k.sub_func_value) {
            v.sub_old =
              ((k.sub_func_value - v.sub_func_value) * 100).toFixed(2) + "↓";
          }
          if (v.func_value === k.func_value) {
            v.sub_old = "--";
          }
          if (v.func_value > k.func_value) {
            v.old = ((v.func_value - k.func_value) * 100).toFixed(2) + "↑";
          } else if (v.func_value < k.func_value) {
            v.old = ((k.func_value - v.func_value) * 100).toFixed(2) + "↓";
          }
          if (v.func_value === k.func_value) {
            v.old = "--";
          }
        }
      });
    });

    return result;
  }
  public get overview_old_data() {
    const overview = readGetSimpleByData(store)?.overview;
    let result = [];
    // UUID层

    for (let device in overview?.old) {
      let device_index = 0;
      // 获取合并行数
      let _device_length = 0;
      for (let _func in overview.old[device]) {
        _device_length += Object.keys(overview.old[device][_func].sub.percent)
          .length;
      }
      // 第一分类
      for (let _func in overview.old[device]) {
        let index = 0;
        if (overview.old[device][_func]) {
          // 第二层分类
          let sub_index = 0;
          for (let _sub_func in overview.old[device][_func].sub.percent) {
            result.push({
              uuid: device,
              func: _func,
              func_value: overview.old[device][_func].value,
              sub_func: _sub_func,
              sub_func_value:
                overview.old[device][_func].sub.percent[_sub_func],
              device_index: device_index,
              index: index,
              // sub_index: sub_index,
              device_length: _device_length,
              length: Object.keys(overview.old[device][_func].sub.percent)
                .length,
              // sub_length: Object.keys(overview[device][_func].sub).length,
            });
            sub_index += 1;
            device_index += 1;
            index += 1;
          }
        } else {
          result.push({
            uuid: device,
            func: _func,
            func_value: overview.old[device][_func].value,
            sub_func: "",
            sub_func_value: "",
            device_index: device_index,
            index: index,
            // sub_index: 0,
            device_length: Object.keys(overview.old).length,
            length: Object.keys(overview.old[device]).length,
            // sub_length: 1,
          });
          device_index += 1;
          index += 1;
        }
      }
    }

    return result;
  }
  public unityMainTable() {
    let list = [];
    let tbodALL = [];
    let l = [];
    if (JSON.stringify(readGetSimpleByData(store)) != "{}") {
      // readGetSimpleByData(store).data['UnityMain中各模块消耗'].list=[
      //     {
      //     label: "Total",
      //     GamePub_LateUpdate: 0.1063229468676826,
      //     UIPanel_LateUpdate: 0.050116314821636386,
      //     GamePub_Update: 0.2931141808976708,
      //     DoForwardShaderRenderLoop: 0.1091416146618252,
      //     is_first: true,
      //     length: 1,
      //     uuid: "6c8a117",
      //     old: {
      //     }
      // },
      // {
      //     label: "Total",
      //     GamePub_LateUpdate: 0.09859965376149363,
      //     UIPanel_LateUpdate: 0.0557543864912948,
      //     abc:2222,
      //     ccc:333,
      //     DoForwardShaderRenderLoop: 0.12601506608834964,
      //     is_first: true,
      //     length: 1,
      //     uuid: "12412412",
      //     old: {}
      // }
      // ]
      readGetSimpleByData(store)?.data["UnityMain中各模块消耗"].list.forEach(
        (v) => {
          if (v.label === this.selected_scene1) {
            list.push(v);
          }
        }
      );
      list.forEach((m, index) => {
        let tbList = [];
        let length = 0;
        for (let obj in m) {
          if (
            obj != "is_first" &&
            obj != "length" &&
            obj != "old" &&
            obj != "label" &&
            obj != "uuid"
          ) {
            tbList.push(obj);

            length += Object.keys(list[index][obj]).length;
          }
        }

        tbList.forEach((v, x) => {
          let i = 0;
          for (let key in list[index][v]) {
            tbodALL.push({
              uuid: list[index].uuid,
              label: key,
              type: v,
              Last:
                JSON.stringify(list[index].old) != "{}"
                  ? list[index].old[key]?.percent
                  : "--",
              LastEventCount:
                JSON.stringify(list[index].old) != "{}"
                  ? list[index].old[key]?.eventCount
                  : "--",
              Cur: list[index][v][key]?.percent,
              CurEventCount: list[index][v][key]?.eventCount,
              length: length,
              fun_length: Object.keys(list[index][v]).length,
              Change: "",
              // is:x,
              // is1:i,
              is_first: x === 0 && i === 0 ? true : false,
              is_first1: i === 0 ? true : false,
            });
            i += 1;
          }
        });
      });
      //   for(let obj in list[0]){
      //     let tbodList=[]
      //   if(obj!='is_first'&&obj!='length'&&obj!='old'&&obj!='label'&&obj!='uuid'){
      //       tbodList.push(obj)
      //   }
      //     console.log(tbodList)
      // }
    }

    return tbodALL;
  }
  public get ehcartList() {
    let list = [];

    for (let i in readGetSimpleByData(store).trend) {
      list.push(i);
    }

    return list;
  }
  public get ehcartListClass() {
    let list = [];

    for (let i in readGetSimpleByData(store).trend_class) {
      list.push(i);
    }

    return list;
  }

  public dateList = [];
  public typeList = [];
  public deviceList = [];
  public subtypeList = [];
  public save_report(is_auto?: boolean) {
    let upload_data: any;

    upload_data = {
      project: this.localProject,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      report_type: this.filterList.type,
      date: this.filterList.date,
      UUID: "",
      subtype: Number(this.filterList.subtype),
      email_type: 19,
      label: this.selected_scene1,
    };
    dispatchNzmUploadReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }

  public get dateOptions() {
    this.dateList = readGetSimpleDateOptions(store);
    return this.dateList;
  }
  public btn(link) {
    const routeUrl = this.$router.resolve({
      path: "/dmo",
      query: { name: link },
    });
    window.open(routeUrl.href, "_blank");
  }
  public drawPieChart(item, index) {
    let ordinates: any[] = [];
    readGetSimpleByData(store).trend[this.selected_scene][
      item
    ].device_list.forEach((v, i) => {
      let list = [];
      ordinates.push({
        name: this.getText(v, false),
        type: "line",
        data: readGetSimpleByData(store).trend[this.selected_scene][item]
          .series[i],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });

    let performance_line: any = document.getElementById(
      "performance_line" + item
    ) as HTMLElement;
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
        data: readGetSimpleByData(store).trend[this.selected_scene][item]
          .params,
      },
      yAxis: {
        min: function (value: any) {
          return Math.floor(value.min * 0.8);
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: readGetSimpleByData(store).trend[this.selected_scene][item].date,
      },

      series: ordinates,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.type = item;
    res.label = this.selected_scene;
    res.file_base64 = res_base64;
    res.filename = "simPleReport" + index + res.type + ".png";
    this.resBase64.push(res);
  }
  public get generateColor() {
    let color = "";
    let r = Math.floor(Math.random() * 256);
    let g = Math.floor(Math.random() * 256);
    let b = Math.floor(Math.random() * 256);
    color = `rgb(${r},${g},${b})`;
    return color;
  }
  public get getRandomColor() {
    return "#" + Math.floor(Math.random() * 256).toString(10);
  }

  public drawPieChart1(item, index) {
    let colors = [];
    for (var i = 0; i < 20; i++) {
      colors.push(
        "rgba( " +
          ((Math.random() * 255) >> 0) +
          "," +
          ((Math.random() * 255) >> 0) +
          "," +
          ((Math.random() * 255) >> 0) +
          "," +
          1 +
          " )",
        "rgba( " +
          ((Math.random() * 255) >> 0) +
          "," +
          ((Math.random() * 255) >> 0) +
          "," +
          ((Math.random() * 255) >> 0) +
          "," +
          0.7 +
          " )"
      );
    }

    let ordinates: any[] = [];
    readGetSimpleByData(store).trend_class[this.selected_scene_class][
      item
    ].params.forEach((v, i) => {
      let list = [];
      ordinates.push({
        name: this.getText(v, false),
        type: "line",
        data: readGetSimpleByData(store).trend_class[this.selected_scene_class][
          item
        ].series[i],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });

    let performance_line: any = document.getElementById(
      "performance_line1" + item
    ) as HTMLElement;
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      color: [
        "rgba(237, 86, 100)",
        "rgba(145, 124, 190)",
        "rgba(94, 190, 181)",
        "rgba(237, 131, 92)",
        "rgba(102, 132, 213)",
        "rgba(250, 203, 97)",
        "rgba(59, 162, 114)",
        "rgba(142, 224, 33)",
        "rgba(15, 41, 42)",
        "rgba(399, 23, 345)",
        "rgba(881, 421, 28)",
        "rgba(123, 122, 28)",
        "rgba(625, 55, 86)",
        "rgba(433, 845, 245)",
        "rgba(556, 123, 321)",
        "rgba(546, 456, 458)",
        "rgba(456, 255, 65)",
        "rgba(67, 45, 68)",
      ],
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
        data: readGetSimpleByData(store).trend_class[this.selected_scene_class][
          item
        ].params,
      },
      yAxis: {
        min: function (value: any) {
          return Math.floor(value.min * 0.8);
        },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: readGetSimpleByData(store).trend_class[this.selected_scene_class][
          item
        ].date,
      },

      series: ordinates,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.type = item;
    res.label = this.selected_scene;
    res.file_base64 = res_base64;
    res.filename = "simPleReport" + index + res.type + "trend_type" + ".png";
    this.resBase64.push(res);
  }
  public resBase64: any[] = []; // 趋势图存储
  public getColor(data, type) {
    if (type == true) {
      if (data.indexOf("↑") != -1) {
        return "#00b050";
      } else if (data.indexOf("↓") != -1) {
        return "red";
      } else {
        return "#212529";
      }
    } else {
      if (data?.indexOf("↑") != -1) {
        return "red";
      } else if (data?.indexOf("↓") != -1) {
        return "#00b050";
      } else {
        return "#212529";
      }
    }
  }
  public getColorNew(newValue, oldValue) {
    if (newValue > oldValue) {
      if ((newValue - oldValue) / oldValue > 0.05) {
        return "red";
      }
    } else {
      return "#212529";
    }
  }
  public getColor1(data) {
    if (data === undefined) {
      return "#212529";
    }
    if (data != undefined) {
      if (data.indexOf("↑") != -1) {
        return "red";
      } else if (data.indexOf("↓") != -1) {
        return "#00b050";
      } else {
        return "#212529";
      }
    }
  }
  public getNone(item, type) {
    if (type === "avg_fps_single" || type === "avg_fps") {
      return item / 100;
    } else {
      return item;
    }
  }
  public loading = false; //加载
  public get typeOptions() {
    this.typeList = readGetSimpleTypeOptions(store);
    return this.typeList;
  }
  // public get deviceOptions() {
  //   this.deviceList = readGetSimpleDeviceOptions(store);
  //   return this.deviceList;
  // }
  public get subtypeOptions() {
    this.subtypeList = readGetSimplSubtypeOptions(store);
    return this.subtypeList;
  }
  public async date(type) {
    this.loading = true;
    if (type === "date") {
      this.formMail.title =
        "【GR自动化】QQ飞车手游SimplePerf自动化测试报告-" +
        this.filterList.date;
      await dispatchSimpleTypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
      });
      this.filterList.type = readGetSimpleTypeOptions(store)[0].report_type;
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      // await dispatchSimpleDeviceOptions(store, {
      //   project: this.localProject,
      //   date: this.dateOptions.length > 0 ? this.filterList.date : "",
      //   report_type:
      //     this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      //   subtype: Number(this.filterList.subtype),
      // });

      // this.filterList.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
    }
    if (type === "type") {
      await dispatchSimpleSubtypeOptions(store, {
        project: this.localProject,
        date: this.dateOptions.length > 0 ? this.filterList.date : "",
        report_type:
          this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      });
      this.filterList.subtype = readGetSimplSubtypeOptions(store)[0].subtype;
      // await dispatchSimpleDeviceOptions(store, {
      //   project: this.localProject,
      //   date: this.dateOptions.length > 0 ? this.filterList.date : "",
      //   report_type:
      //     this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      //   subtype: Number(this.filterList.subtype),
      // });

      // this.filterList.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
    }
    // if (type === "subtype") {
    //   await dispatchSimpleDeviceOptions(store, {
    //     project: this.localProject,
    //     date: this.dateOptions.length > 0 ? this.filterList.date : "",
    //     report_type:
    //       this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
    //     subtype: Number(this.filterList.subtype),
    //   });
    //   // this.filterList.uuid = readGetSimpleDeviceOptions(store)[0].UUID;
    // }
    // if (type === "device") {
    //   await dispatchSimpleDeviceOptions(store, {
    //     project: this.localProject,
    //     date: this.dateOptions.length > 0 ? this.filterList.date : "",
    //     report_type:
    //       this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
    //     subtype: Number(this.filterList.subtype),
    //   });
    // }
    await dispatchSimpleByData(store, {
      project: this.localProject,
      date: this.dateOptions.length > 0 ? this.filterList.date : "",
      report_type:
        this.typeOptions.length > 0 ? Number(this.filterList.type) : "",
      UUID: "",
      subtype: Number(this.filterList.subtype),
    });
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.filterList.date,
        report_type: Number(this.filterList.type),
        UUID: "",
        subtype: this.filterList.subtype,
      },
    });

    await this.simpleByData;
    await this.picData;
    await this.textData;

    this.resBase64 = [];
    this.selected_scene =
      this.tableObj1.trend.Total === undefined ? this.ehcartList[0] : "Total";
    this.selected_scene_class =
      this.tableObj1.trend_class.Total === undefined
        ? this.ehcartList[0]
        : "Total";

    if (this.simpleByData.trend.Total === undefined) {
      this.selected_scene1 = this.ehcartList[0];
    } else {
      this.selected_scene1 = "Total";
    }
    await this.unityMainTable();
    await this.trendLabel(this.selected_scene).forEach((v, index) => {
      this.$nextTick(() => {
        this.drawPieChart(v, index);
      });
    });
    await this.trendLabel1(this.selected_scene_class).forEach((v, index) => {
      this.$nextTick(() => {
        this.drawPieChart1(v, index);
      });
    });
    // this.show=false
    // this.show=true

    //            for(let i in this.tableObj1.data){
    //     if(i!='UnityMain中各模块消耗'){
    //       this.tableObj1.data[i].list.forEach((v,index) => {

    //  this.$nextTick(() => {
    //     let chil=document.getElementById(index+i+String(v.is_first))
    //    let num=(chil.children[0] as any).getAttribute('rowspan')
    //    if(num=='1'&&String(v.is_first)=='false'&&index!=1){

    //        chil.removeChild(chil.children[0]);
    //      } })

    //    });
    //     }

    // }

    this.loading = false;
  }
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public tableObj = {};
  public tableObj1: any = {};
  public text = [];
  public pic = {};
  public trend = {};
  public get simpleData() {
    this.tableObj = readGetSimpleData(store).data;
    return this.tableObj;
  }
  public get simpleByData() {
    this.tableObj1 = readGetSimpleByData(store);

    return this.tableObj1;
  }
  public get picData() {
    this.pic = readGetSimpleByData(store).pic;
    return this.pic;
  }
  public get textData() {
    this.text = readGetSimpleByData(store).text;

    return this.text;
  }
  public show = true;
  public get fps_dict() {
    return readGetSimpleByData(store).fps_dict;
  }
  public getText(item, type) {
    if (item === "") {
      return "--";
    }
    if (this.simpleByData.device_dict[item] != undefined) {
      if (type) {
        return this.simpleByData.device_dict[item];
      } else {
        return (
          this.simpleByData.device_dict[item] + "(" + this.fps_dict[item] + ")"
        );
      }
    } else {
      return item;
    }
  }

  public name_search = "";
  //声明属性
  // public tableObj={
  //     UnityMain中各线程消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'1.20%'}]},
  //     UnityMain中各模块消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'6.20%'}]}
  //     ,UnityMain中各SO消耗:{head:[{name:'测试皮肤',value:'testName'},{name:'平均帧率',value:'avg'},{name:'单帧平均耗时',value:'avgMs'},{name:'UnityMain',value:'unity'},{name:'UnityGfx',value:'unityGfx'},{name:'CoreThread',value:'corethead'},{name:'NativeThread',value:'navite'},{name:'WorkerThread(*2)',value:'work'},{name:'Other',value:'other'}],list:[{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'7.20%'},{testName:'10500-云中君-经典',avg:'22.4',avgMs:'44.64',unity:'35.20%',unityGfx:'27.70%',corethead:'22.20%',navite:'23.5%',work:'11.30%',other:'6.20%'}]}
  //     ,火焰图展示:{head:[{name:'测试皮肤',value:'testName'},{name:'火焰图下载链接',value:'link'},],list:[{testName:'10500-云中君-经典',link:'下载',},{testName:'10500-云中君-经典',link:'下载',}]}
  // }
}
